// extracted by mini-css-extract-plugin
module.exports = {"container":"Placeholder_container__2BGda","caption":"Placeholder_caption__20m5y","content":"Placeholder_content__17kHP","contentCol":"Placeholder_contentCol__vbBlx"};